__gh__webApp.paywall.pianoVX = {

	"loginSuccessCounter": 0,
	"experienceCounter": 0,
	"refreshExperienceCallbacks": [],

	"init": function(){
	
		if (this.isDisabled()) {return;}
		
		__gh__webApp.paywall.loginSuccessCounter = 0;
		 
		this.updateLoginLogoutText();
		this.bindEvents();
	},
	
	
	"bindEvents":function(){
		var thisObject = __gh__webApp.paywall;
		
		//Login event
		$(document).on('click.paywall-login','[data-gh-paywall-event=login]',function(event){
			event.preventDefault();
			var eventObject 	= $(this).data("gh-paywall-event-object"),
				callbackObject	= (eventObject && "callbackObject" in eventObject) ? eventObject.callbackObject : null;
			
			thisObject.showUserLoginForm(callbackObject);
		});
		
		//Logout event
		$(document).on('click','[data-gh-paywall-event=logout]',function(event){
			event.preventDefault();
			thisObject.logout();
		});
	},
	
	
	"isDisabled": function(){
		var commonJS = __gh__webApp.common;
		return (__gh__coreData["3rdPartyData"].paywall.pianoVX.disabled || !commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"paywall.pianoVX.aid"));
	},
	
	
	"isUserLoggedIn": function(){
		if (this.isDisabled()) {return false;}
		var commonJS 	= __gh__webApp.common,
			userCookie;
		if(userCookie = commonJS.getCookie("__ut")){
			return userCookie;
		}
		return false;
	},
	
	
	"showUserLoginForm": function(callbackObject){
		if (this.isDisabled()) {return false;}
		
		var commonJS	= __gh__webApp.common,
			thisObject 	= __gh__webApp.paywall;
		tp.push(["init", function() {
			tp.user.showLogin({  
				loginSuccess:function() {
					//Make sure it only runs once
					__gh__webApp.paywall.loginSuccessCounter++;
					if (__gh__webApp.paywall.loginSuccessCounter > 1) {return;}
					
					thisObject.updateLoginLogoutText();
					thisObject.refreshExperience();
					
					if (callbackObject){
						commonJS.callFunction(callbackObject);
					}
					
				} 
			});
		}]);
	},
	
	"showOffer": function(options){
		if (this.isDisabled()) {return false;}
		
		var commonJS = __gh__webApp.common,
			offer = {
				"displayMode"	: (options.displayMode) ? options.displayMode : "modal",
				"templateId"	: (options.templateId) ? options.templateId : null,
				"offerId"		: (options.offerId) ? options.offerId : null
			};
		
		//Remove null or undefined items
		offer = commonJS.cleanObject(offer);
		
		tp.push(["init", function() {
		    tp.offer.show(offer);
		}]);
	},
	
	"updateLoginLogoutText": function(){
		if (this.isDisabled()) {return false;}
		
		var thisObject 	= __gh__webApp.paywall,
			$loginLink	= $("#toprail-login").find("a");
		
		//Log out text
		if (thisObject.isUserLoggedIn()) {
			$loginLink.find("span").html("log out");
			$("[data-gh-paywall-event]").attr("data-gh-paywall-event","logout");
			return;
		}
	
		//Log in text
		$loginLink.find("span").html("log in");
		$("[data-gh-paywall-event]").attr("data-gh-paywall-event","login");
		
	},
	
	
	"logout":function(){
		if (this.isDisabled()) {return false;}
		
		var thisObject = __gh__webApp.paywall;
		tp.push(["init", function() {
			tp.user.logout(function(){
				thisObject.updateLoginLogoutText();
				__gh__webApp.paywall.loginSuccessCounter = 0;
				__gh__webApp.localStorage.removeItem('_vxData');//remove stored Piano VX user data
			});
		}]);
	},
	
	
	"userLogin":function(callback){
		var callback = callback || null;
		this.showUserLoginForm(callback);
	},
	
	"refreshExperience": function(options){
		if (this.isDisabled()) {return;}
		var options = (options) ? options : {},
			tags 	= ("tags" in options) ? options.tags : [];
		
		// Set Tags
		if (tags.length){
			tp.push(["setTags", tags]);
		}
		
		// Execute Experience
		tp.experience.execute();
	},
	
	
	"refreshArticleExperience": function(articleObject){
		var thisObject	= __gh__webApp.paywall;
		if (thisObject.isDisabled()) {return;}
		
		var commonJS 	= __gh__webApp.common,
			freemium 	= commonJS.getObjectProperty(__gh__coreData["3rdPartyData"],"paywall.pianoVX.freemium"),
			isMetered 	= articleObject.metered,
			tags		= ((freemium && isMetered) || !freemium)  ? ["metered"] : [];
	
		thisObject.refreshExperience({
			"tags": tags
		});
		
	},
	
	
	"vxStorage": function(data){
		var _vxData = {
				"email"		: data.user.email,
				"id"		: data.user.uid,
				"access"	: data.accessList.length,
				"name"		: data.user.firstName+" "+data.user.lastName,
				"firstName"	: data.user.firstName,
				"lastName"	: data.user.lastName
			},
			localStorage = __gh__webApp.localStorage;
		
		
		if(!localStorage.getItem("_vxData")){
			localStorage.setItem("_vxData",JSON.stringify(_vxData));
			return;
		}
		
		localStorage.removeItem("_vxData");
		localStorage.setItem("_vxData",JSON.stringify(_vxData));
	},

	/**
	 * Library is loaded server side
	 */
	"loadLibrary": function() {},
	
	"meterArticle": function(articleID){},
	
	"sessionBar":{"incrementTotalPremiumClicks":function(){}},
};
